import { Dialog, DialogTitle, Button, DialogContentText, DialogActions, DialogContent } from "@mui/material";

function DialogMessage(props) {


    const handleClose = () => { props.setOpen(false) };
    return (
        <>
            <Dialog onClose={handleClose} open={props.open} aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{props.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="info" onClick={handleClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default DialogMessage;